// extracted by mini-css-extract-plugin
module.exports = {"title":"ProductItem_title__2sLtl","link":"ProductItem_link__xC6HN","img":"ProductItem_img__2APnm","price":"ProductItem_price__3PNPc","description":"ProductItem_description__5tBiB"};